import axios from 'axios'

export default {
  delete: async (sitePath, id) => {
    const url = `${sitePath}/businessprocess/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url =
      id === undefined
        ? `${sitePath}/businessprocess/`
        : `${sitePath}/businessprocess/${id}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/businessprocess/`
    const response = await axios({
      method: 'post',
      url: url,
      data: data,
      config: {
        headers: { 'Content-Type': 'application/json' },
      },
    })
    //    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/businessprocess/${id}/`
    const response = await axios.put(url, data)

    return response.data
  },
}
